import React from "react";
import styles from "./header.module.scss";
import { Navbar } from "../navbar/navbar";

export const Header = () => {
  return (
    <div className={styles.header}>
        <div className={styles.logo}>LOGO</div>
        <Navbar />
        <div className={styles.user} role="button">USER NAME</div>
    </div>
  );
};
